import { Chip as ChipCore } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import * as lib from '~/dependencies';
import { colors } from '~/layout';

export const AssignedChip = lib.styled(ChipCore)`
  background-color: ${colors.white};
  color: ${(props: { variant: string }) =>
    props.variant === 'outlined'
      ? colors.lightBlue12
      : colors.darkGray11} !important;

  border: 1px solid ${(props: { variant: string }) =>
    props.variant === 'outlined'
      ? colors.lightBlue12
      : colors.darkGray11} !important;

  .MuiSvgIcon-root {
    fill: ${(props: { variant: string }) =>
      props.variant === 'outlined'
        ? colors.lightBlue12
        : colors.darkGray11} !important;
  }

  .MuiChip-label {
    max-width: 50px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

export const GroupHeader = lib.styled.div`
    position: sticky;
    top: -8px;
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 5px;
    font-weight: 700;
    background-color: ${colors.white};
    color: ${colors.darkGray11};

    svg {
      width: 18px;
      height: 18px;
      color: ${colors.lightBlue16};
      margin-top: -3px;
      opacity: 0.7;
      
    }
`;

export const GroupItems = lib.styled.ul``;

export const useStyles = makeStyles(theme => ({
  popper: {
    border: '1px solid #e2e2e2',
    boxShadow: '0 3px 12px rgba(27,31,35,.15)',
    borderRadius: 3,
    width: 250,
    zIndex: 3, // List conversations is 2
    fontSize: 13,
    backgroundColor: '#f9f9f9',
  },
  inputBase: {
    padding: 10,
    width: '100%',
    borderBottom: '1px solid #e2e2e2',
    '& input': {
      borderRadius: 4,
      backgroundColor: theme.palette.common.white,
      padding: 8,
      transition: theme.transitions.create(['border-color', 'box-shadow']),
      border: '1px solid #e2e2e2',
      fontSize: 13,
      '&::placeholder': {
        fontStyle: 'italic',
      },
    },
  },
  paper: {
    boxShadow: 'none',
    margin: 0,
    color: '#586069',
    fontSize: 13,
    zIndex: 50000,
    height: 180,
    maxHeight: 180,
    overflowY: 'auto',
  },
  option: {
    minHeight: 'auto',
    alignItems: 'flex-start',
    padding: 8,
    '&[aria-selected="true"]': {
      backgroundColor: 'transparent',
    },
    '&[data-focus="true"]': {
      backgroundColor: theme.palette.action.hover,
    },
  },
  popperDisablePortal: {
    position: 'relative',
  },
}));
